module.exports = __webpack_public_path__ + "img/default-photo.833d9eec.png";